<template>
  <div id="courseviewerquiz" ref="whole_page">
    <div v-show="isCardActiveLocal && !quizResult && !surveyResponse && !loadingResults">

      <div v-if="quiz.timeLimit != 0" class="timerdiv centereverything">
        <p id="timer" class="font-bold timer disable-select">
          Time:
          <strong>{{
            quizTimeLeft ? quizTimeLeft : formatTime(quiz.timeLimit * 60)
          }}</strong>
        </p>         
      </div>      
      
      <div v-show="!isQuizActive">
        <div  class="clickpagequizviewer">
          <div class="quizheading centereverything disable-select">Quiz</div>

          <div class="vx-row">
            <div v-html="quiz.title" class=" vx-col w-full heading disable-select"></div>
          </div>
          
          <div v-if="quiz.imageUrl" class="quizimage">
            <img :src="quiz.imageUrl" class="clickimageactive" style="width: 100%; height: 100%; border-radius:15px;">
          </div>

          <div class="vx-row">
            <div v-html="quiz.description" class="vx-col w-full quiz-description disable-select"></div>
            <vs-button v-if="quiz.questions" style="left: 15px; cursor: default" v-html="'Total Question(s): ' + quiz.questions.length"></vs-button>
          </div>

          <div v-if="timeCapture">
            <div v-show="timeCapture && timeCapture.captureTimeForAssessments && $siteTypeId() != 1" class="hoursUsed mb-8 mt-4">
              <p class="mb-2"> How many hours did you spend preparing for the assessment? </p>
              <vue-slider
                class="w-full mb-5"
                :tooltip="'none'"
                v-model="timeCaptureOnQuiz"
                :adsorb="true"
                :min="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMinFormatives : timeCapture.sliderMinSummatives"
                :max="timeCapture.taskClassificationTypeId == 1 ? timeCapture.sliderMaxFormatives : timeCapture.sliderMaxSummatives"
                :data-label="'id'"
                :data-value="'id'"
                :marks="true"
              ></vue-slider>
            </div>
          </div>

        </div>
        
        <div class="vx-row mt-5">
          <div class="vx-col startbuttons">   
            <div v-if="(quiz.showStartOption || rewrite)" class="flex helpful_btns__container justify-center">
              <vs-button id="start-btn" class="vs-con-loading__container  clickbuttonactive" ref="submit_btn" icon-pack="feather" icon="icon-play" @click="startQuiz">Start</vs-button>
              <vs-button v-if="isCardActiveLocal && !quiz.standalone && !isQuizPopup" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
            </div>
            
            <div v-if="quiz.showSkipOption" class="flex helpful_btns__container justify-center">
              <vs-button id="skip-btn" class="vs-con-loading__container clickbuttonactive" color="success" ref="submit_btn" icon-pack="feather" icon="icon-skip-forward" @click="nextTask">Skip</vs-button>                     
            </div>

            <div v-if="(quiz.showContinueOption || quiz.showRetryOption) && !quiz.showRedoOption" class="flex helpful_btns__container justify-center">
              <vs-button v-if="isCardActiveLocal && !quiz.standalone && !isQuizPopup" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />              
              <vs-button  id="helpful-btn" class="vs-con-loading__container  clickbuttonactive" ref="submit_btn" icon-pack="feather" icon="icon-repeat" icon-after @click="retryQuiz">Retry</vs-button>
              <vs-button id="unhelpful-btn" class="vs-con-loading__container  clickbuttonactive" ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after @click="continueQuiz">Continue</vs-button>                        
            </div>

            
          </div>
        </div>
      </div>

      <!-- Question Content -->
      <div>
        <question-single-select
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 1 && isCardActive"
          :question="quiz.questions[index]"
          :key="`${index}mcss`"
          :isStandalone="quiz.standalone"
          :isStudent ="isStudentProp"
        />
        <question-multiple-select
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 2 && isCardActive"
          :key="`${index}mcms`"
          :question="quiz.questions[index]"
          :isQuizJournal="quiz.isJournal"
          :isStandalone="quiz.standalone"
          :isStudent ="isStudentProp"
        />
        <question-free-text
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 3 && isCardActive"
          :question="quiz.questions[index]"
          :isStudent ="isStudentProp"
        />
        <question-table
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 4 && isCardActive"
          :question="quiz.questions[index]"
          @tableUpdated="tableUpdated"
          :key="`${index}table`"
          :isStudent ="isStudentProp"
        />
        <question-drag-and-drop
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 5 && isCardActive"
          :runInit="runDragAndDropInit"
          :question="quiz.questions[index]"
          :isStudent ="isStudentProp"
          :index="index"
        />
        <question-upload
          v-if="quiz.questions && index >= 0"
          :isCardActive="currentQuestionType == 6 && isCardActive"
          :question="quiz.questions[index]"
          :isStudent ="isStudentProp"
        />
      </div>

      <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">

        <div class="nextbuttons">

          <div class="flex next_btns__container justify-center pr-1 pl-2">
            <vs-button v-if="isCardActiveLocal && !quiz.standalone && !isQuizPopup && $route.name != 'Menu'" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg" icon-pack="feather" icon="icon-help-circle" />
            <vs-button v-if="isCardActiveLocal && quiz.standalone && !isQuizPopup && $route.name != 'Menu'" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg helpbuttonforstandalone" icon-pack="feather" icon="icon-help-circle" />
            <vs-button v-if="isCardActiveLocal && isQuizPopup && $route.name != 'Menu'" id="help-btn" @click="helpPopupActive = true" radius color="danger" type="filled" size="large" class="shadow-lg helpbuttonforquizpop" icon-pack="feather" icon="icon-help-circle" />
            <vs-button v-show="isQuizActive && index + 1 != 1" id="next-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
            ref="submit_btn" icon-pack="feather" icon="icon-arrow-left" 
            :disabled="isTimeUp || (quiz.answerRequired && !isQuestionAnswered)" 
            @click="previousQuestion">Previous</vs-button>
            <vs-button v-if="quiz.questions" style="cursor: default" v-show="quizeIndex > 0" v-html=" quizeIndex + '/' + quiz.questions.length" id="quize-counter" ref="submit_btn" icon-pack="feather" icon="icon-play"></vs-button>
          </div>

          <div class="flex next_btns__container justify-center">
            <vs-button v-show="isQuizActive && index + 1 != quiz.questions.length" id="next-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
            ref="submit_btn" icon-pack="feather" icon="icon-arrow-right" icon-after
            :disabled="isTimeUp || (quiz.answerRequired && !isQuestionAnswered)"
            @click="nextQuestion">Next</vs-button>
          </div>

          <div class="flex next_btns__container justify-center">
            <vs-button v-show="isQuizActive && index + 1 == quiz.questions.length" id="next-btn" class="vs-con-loading__container next_btns clickbuttonactive" 
            ref="finishQuiz" icon-pack="feather" icon="icon-check" icon-after
            :disabled="finishClicked || (quiz.answerRequired && !isQuestionAnswered)"
            @click="areYouSure">Finish</vs-button>
          </div>
        </div>
      </vs-row>
        <img id="back-arrow-quiz" v-show="isBackAllowed && !styleB" @click="backToTask" v-if="$route.params.isStudent" src="../../assets/images/digi-back-arrow.png"/>
    </div>
    
    <quiz-result
      :errorDataProp="errorDataProp"
      :taskIdProp="taskIdProp"
      :isCardActive="quizResult && isCardActive"
      :quizResponse="quizResponse"
      :cardHeight="cardHeight"
      :cardWidth="cardWidth"
      @nextTask="nextTask"
      :isStudentProp="isStudentProp"
      @backToStudentMenu="backToStudentMenu"
      :styleB="styleB"
    />
    <survey-response
      :errorDataProp="errorDataProp"
      :taskIdProp="taskIdProp"
      :isCardActive="surveyResponse && isCardActive"
      :quizResponse="quizResponse"
      :cardHeight="cardHeight"
      :cardWidth="cardWidth"
      @nextTask="nextTask"
      :isStudentProp="isStudentProp"
      :styleB="styleB"
    />
    <loading-results
      :errorDataProp="errorDataProp"
      :taskIdProp="taskIdProp"
      :isCardActive="loadingResults && isCardActive"
      :cardHeight="cardHeight"
      :cardWidth="cardWidth"
    />

    <vs-popup title="Having some problems?" :active.sync="helpPopupActive">
      <p class="pb-2">Please tell us about the issues you are experiencing:</p>
      <vs-textarea v-model="errorData.userMessage" />
      <p class="pb-2">Your WhatsApp number:</p>
      <vs-input autocomplete="off" v-validate="'digits:10'" name="WhatsApp number" v-model="errorData.whatsappNumber" />
      <span class="text-danger text-sm" v-show="errors.has('WhatsApp number')">{{ errors.first('WhatsApp number') }}</span>
      <div class="mt-3">
        <vs-button color="success" class="float-right" @click="submitIssue">Submit</vs-button>
      </div>
    </vs-popup>

  </div>
</template>

<script>
import { setInterval } from "timers";
import questionTable from "./QuestionTable.vue";
import questionFreeText from "./QuestionFreeText.vue";
import questionUpload from "./QuestionUpload.vue";
import questionSingleSelect from "./QuestionSingleSelect.vue";
import questionMultipleSelect from "./QuestionMultipleSelect.vue";
import questionDragAndDrop from "./QuestionDragAndDrop.vue";
import quizResult from "./QuizResult.vue";
import surveyResponse from "./SurveyResponse.vue";
import loadingResults from "./LoadingResults";
import { uuid } from "vue-uuid";
import moment from "moment";
import jQuery from '../../views/coursebuilder/jquery';
import VueSlider from 'vue-slider-component'
import 'animate.css';

export default {
  components: {
    VueSlider,
    questionTable,
    questionFreeText,
    questionSingleSelect,
    questionMultipleSelect,
    questionDragAndDrop,
    quizResult,
    surveyResponse,
    questionUpload,
    loadingResults,
    moment
  },
  props: {
    isCardActive: {
      type: Boolean,
      required: true
    },
    quiz: {
      type: Object,
      required: true
    },
    cardHeight: {
      type: Number,
      required: false
    },
    cardWidth: {
      type: Number,
      required: false
    },
    uuid: {
      type: String,
      required: false
    },
    isStudentProp: {
      type: Boolean,
      required: false
    },
    isBackAllowed: {
      type: Boolean,
      required: false
    },
    errorDataProp: {
      type: Object,
      required: false
    },
    taskIdProp: {
      type: Number,
      required: false
    },
    cameras: {
      required: false
    },
    logData: {
      type: Object,
      required: false
    },
    taskTypeId: {
      type: Number,
      required: false
    },
    resetQuizButtons: {
      type: Boolean,
      required: false
    },
    moduleId: {
      type: Number,
      required: false
    },
    styleB: {
      type: Boolean,
      required: false
    },
    isQuizPopup: {
      type: Boolean,
      required: false
    },
    timeCapture: {
      type: Object,
      required: false
    },
    rewrite:{
      type:Boolean,
      required:false
    }
  },
  data() {
    return {
      quizeIndex: 0,
      quizTime: "",
      quizOrigTimeLimit: 0,
      counter: null,
      timeout: null,
      quizTimeLeft: null,
      isQuizActive: false,
      index: -1,
      duration: 0,
      quizResultData: {
        duration: 0,
        logIdentifier: "",
        quizId: 0,
        questions: [],
        timeCapture: null,
      },
      quizResponse: {},
      quizResult: false,
      isTimeUp: false,
      isQuestionAnswered: false,
      surveyResponse: false,
      loadingResults: false,
      startBtnDisabled: false,
      startBtnCaption: "Start",
      helpPopupActive: false,
      canSkip:false,
      errorData: {
        userId: null,
        taskId: null,
        userMessage: "",
        osName: "",
        osVersion: "",
        browserName: "",
        browserVersion: "",
        navigatorUserAgent: "",
        navigatorAppVersion: "",
        navigatorPlatform: "",
        navigatorVendor: "",
        isMobile: false,
        whatsappNumber: ""
      },
      finishClicked: false,
      timeCaptureOnQuiz: null,
      runDragAndDropInit: false,
      oldIndex: 0,
      hideImage :false,
    };
  },
  watch: {
    isCardActive: {
      deep: true,
      immediate: true,
      handler(val) {
        var self = this;
        self.initValues();
        if (val) {
          if(!self.quiz.standalone)
            self.$store.dispatch("updateTheme", "light");
          
          self.initQuizAndQuestions();
          self.displayOneTaskAttemptPopup();
        }
      }
    },
    questionChangedCheck: function(val){
      var self = this;
      self.tempTypeId = self.quiz.questions[self.index].quizQuestionTypeId;
      self.quiz.questions[self.index].quizQuestionTypeId = 0;
    },
    resetQuizButtons: function(val){
      this.initQuizAndQuestions();
    },
    quiz: {
      deep: true,
      immediate: true,
      handler(val) {
        var self = this;
        if (
          Object.keys(self.quiz).length != 0 &&
          self.quiz.questions &&
          self.quiz.questions.length > 0 &&
          self.index > -1
        ) {
          if (self.currentQuestionType == 1) {
            self.isQuestionAnswered = self.quiz.questions[self.index]
              .inputAnswer
              ? true
              : false;
          } else if (self.currentQuestionType == 2) {
            if (
              self.quiz.questions[self.index].options.filter(function(item) {
                return item.isSelected;
              }).length > 0
            ) {
              self.isQuestionAnswered = true;
            } else {
              self.isQuestionAnswered = false;
            }
          } else if (self.currentQuestionType == 3) {
            self.isQuestionAnswered = self.quiz.questions[self.index]
              .inputAnswer
              ? true
              : false;
          } else if (self.currentQuestionType == 4) {
            self.isQuestionAnswered = self.somethingInTable();
          }
          else if (self.currentQuestionType == 6) {
            self.hideImage = true;
            self.isQuestionAnswered = self.quiz.questions[self.index].uploadedFile.length
            ? true
            : false;
          }
        }
      }
    },
    index: function(val) {
      var self = this;
      if (val > -1) {
        if (self.currentQuestionType == 1) {
          self.isQuestionAnswered = self.quiz.questions[self.index].inputAnswer
            ? true
            : false;
        } else if (self.currentQuestionType == 2) {
          if (
            self.quiz.questions[self.index].options.filter(function(item) {
              return item.isSelected;
            }).length > 0
          ) {
            self.isQuestionAnswered = true;
          } else {
            self.isQuestionAnswered = false;
          }
        } else if (self.currentQuestionType == 3) {
          self.isQuestionAnswered = self.quiz.questions[self.index].inputAnswer
            ? true
            : false;
        } else if (self.currentQuestionType == 4) {
          self.isQuestionAnswered = self.somethingInTable();
        } else if (self.currentQuestionType == 5) {
          self.runDragAndDropInit = !self.runDragAndDropInit;
        }
        else if (self.currentQuestionType == 6) {
          self.hideImage = true;
          self.isQuestionAnswered = self.quiz.questions[self.index].uploadedFile.length
            ? true
            : false;
        }
      }
    },
    cameras: function(val) {
      if (!val && quiz.isDecisive) {
        this.startBtnDisabled = true;
      } else {
        this.startBtnDisabled = false;
      }
    }
  },
  computed: {
    isCardActiveLocal: {
      get() {
        return this.isCardActive;
      },
      set(val) {
        if (!val) {
          this.initValues();
        }
      }
    },
    currentQuestionType: function() {
      if (this.quiz && this.quiz.questions && this.index >= 0) {
        if (this.quiz.questions[this.index]) {
          if(this.index == 0){
            return this.quiz.questions[this.index].quizQuestionTypeId;
          }
          else {
            return this.quiz.questions[this.index].quizQuestionTypeId;
          }
        }
      }
      return false;
    },

  },
  methods: {
    backToTask(){
      this.$store.dispatch("updateTheme", "dark");
      this.$emit("backToTask");
    },
    somethingInTable: function() {
      var self = this;
      return (
        self.quiz.questions[self.index].rowValues.filter(
          x => Object.values(x).filter(y => y).length >= 3
        ).length > 0
      );
    },
    somethingChanged(val) {
      var self = this;
      if (
        Object.keys(self.quiz).length != 0 &&
        self.quiz.questions.length > 0 &&
        self.index > -1
      ) {
        if (self.currentQuestionType == 1) {
          self.isQuestionAnswered = self.quiz.questions[self.index].inputAnswer
            ? true
            : false;
        } else if (self.currentQuestionType == 2) {
          if (
            self.quiz.questions[self.index].options.filter(function(item) {
              return item.isSelected;
            }).length > 0
          ) {
            self.isQuestionAnswered = true;
          } else {
            self.isQuestionAnswered = false;
          }
        } else if (self.currentQuestionType == 3) {
          self.isQuestionAnswered = self.quiz.questions[self.index].inputAnswer
            ? true
            : false;
        } else if (self.currentQuestionType == 4) {
          self.isQuestionAnswered = val.length ? true: false;
        }else if (self.currentQuestionType == 6){
          self.isQuestionAnswered = self.quiz.questions[self.index].uploadedFile.length
            ? true
            : false;
        }

      }
    },
    tableUpdated(val) {
      this.somethingChanged(val);
    },
    initValues() {
      this.quizeIndex = 0;
      this.isQuizActive = false;
      this.index = -1;
      this.quizOrigTimeLimit = 0;
      this.duration = 0;
      this.quizTime = "";
      this.counter = null;
      this.timeout = null;
      this.quizTimeLeft = null;
      this.quizResultData = {};
      this.quizResponse = {};
      this.quizResult = false;
      this.isTimeUp = false;
      this.timeCaptureOnQuiz = null;
      (this.isQuestionAnswered = false), (this.surveyResponse = false);
      this.loadingResults = false;
    },
    backToStudentMenu() {
      this.$router.push("/menu");
    },
    clearData() {
      this.quizResultData = {};
      this.quizResponse = {};
    },
    nextTask() {
      var self = this;
      this.initValues();
      this.$store.dispatch("updateTheme", "dark");     
      if(self.styleB){
        if (self.$route.query.outcome) {
          self.$router.push({ name: "Gen2OutcomeTasks", query: { moduleId: self.$route.params.moduleId, lpName: self.$route.query.lpName, lpNumber: self.$route.query.lpNumber, selectedTaskGroup: self.$route.query.selectedTaskGroup, selectedOutcome: self.$route.query.selectedOutcome, timeCapture: JSON.stringify(self.timeCapture) }});
        } else {
          if(self.$route.params.styleB)
            self.$router.push({ name: 'LearningStyleBViewer', params: { moduleId: self.$route.params.moduleId, checkTimeCapture: true }})
          else
            self.$router.push('/menu');
        }
      }
      else {
        this.$emit("nextTask");
      }
    },
    startQuiz() {
      var self = this;
      self.$emit("hideBackButton");
      if (self.quiz.allowOnlyOnce) {
        self.$vs.dialog({
          color: "warning",
          title: `Information`,
          text:
            "Please make sure of your answers before submitting them, because this quiz can only be done once.",
          acceptText: "OK, got it!",
          accept: self.continueToStart
        });
      } else self.continueToStart();

      if(self.quiz.timeLimit != 0){
        self.$emit("hideHomeButton");
      }

      self.logQuizStarted();
    },
    skipQuiz(){

    },
    continueQuiz() {
      var self = this;
      self.$emit("hideBackButton");
      self.isQuizActive = true;

      if(self.quiz.timeLimit != 0){
        self.$emit("hideHomeButton");        
      }
      ++self.quizeIndex;
      ++self.index;
    },
    continueTimer() {
      var self = this;
      var timerDiv = document.getElementById("timer");

      if (self.quiz.timeLimit != 0) {
        var startTime = moment(self.quiz.startedOn);

        var endTime = startTime.add(self.quiz.timeLimit, "minutes");

        var diff_milliseconds = Math.abs(moment().diff(endTime));
        var diff_seconds = Math.abs(moment().diff(endTime, "seconds"));

        self.counter = setInterval(function() {
          if (diff_seconds != 0) {
            diff_seconds--;
            self.quizTimeLeft = self.formatTime(diff_seconds);
          }
        }, 1000);

        setInterval(function() {
          var diffseconds = Math.abs(moment().diff(endTime, "seconds"));
          if (diffseconds < self.quiz.timeLimit * 12 && diffseconds != 0) {
            // 60*0.2 = 12
            timerDiv.style.opacity =
              timerDiv.style.opacity == "1" ? "0.2" : "1";
          }
        }, 300);

        self.timeout = setTimeout(function() {
          if (!self.quizResult) {
            self.isTimeUp = true;
            self.finishQuiz(true);
          }
        }, diff_milliseconds);
      }
    },
    retryQuiz() {
      var self = this;
      self.$emit("hideBackButton");
      if(self.counter){
        clearInterval(self.counter._id);
      }
    
      self.quizTimeLeft = self.formatTime(self.quiz.timeLimit * 60);
      self.endQuizTaskLog(() => {
        self.logQuizFinished(() => {
          self.logData.logIdentifier = self.$uuid.v4();
          self.initQuizAndQuestions();
        });
      });
    },
    continueToStart() {
      var self = this;
      self.isQuizActive = true;
      ++self.index;
      ++self.quizeIndex;
      var timerDiv = document.getElementById("timer");

      if (self.quiz.timeLimit != 0) {
        self.quizOrigTimeLimit = self.quiz.timeLimit * 60;
        self.counter = setInterval(function() {
          if (self.quizOrigTimeLimit != 0) {
            self.timer(self.quizOrigTimeLimit);
          }
        }, 1000);

        setInterval(function() {
          if (
            self.quizOrigTimeLimit < self.quiz.timeLimit * 12 &&
            self.quizOrigTimeLimit != 0
          ) {
            timerDiv.style.opacity =
              timerDiv.style.opacity == "1" ? "0.2" : "1";
          }
        }, 300);

        self.timeout = setTimeout(function() {
          if (!self.quizResult) {
            self.isTimeUp = true;
            self.finishQuiz(true);
          }
        }, self.quizOrigTimeLimit * 1000);
      }
    },
    timer() {
      var self = this;
      self.quizOrigTimeLimit--;
      self.quizTimeLeft = self.formatTime(self.quizOrigTimeLimit);
    },
    formatTime(seconds) {
      var self = this;
      var h = Math.floor(seconds / 3600);
      var m = Math.floor(seconds / 60) % 60;
      var s = seconds % 60;
      if (h < 10) h = "0" + h;
      if (m < 10) m = "0" + m;
      if (s < 10) s = "0" + s;
      self.quizTime = h + ":" + m + ":" + s;
      return self.quizTime;
    },
    msToTime(s) {
      var ms = s % 1000;
      s = (s - ms) / 1000;
      var secs = s % 60;
      s = (s - secs) / 60;
      var mins = s % 60;
      var hrs = (s - mins) / 60;

      if (hrs < 10) hrs = "0" + hrs;
      if (mins < 10) mins = "0" + mins;
      if (secs < 10) secs = "0" + secs;

      return hrs + ":" + mins + ":" + secs;
    },
    finishQuiz(val) {
      var self = this;
      
      self.finishClicked = true;
      self.showLoadingOnElement("finishQuiz", 0.45, "material");
      self.logQuizFinished(val);

      if (self.quiz.timeLimit != 0) {
        clearInterval(self.counter._id);
        self.duration = self.quiz.timeLimit * 60 - self.quizOrigTimeLimit;
        self.quizResultData.duration = self.duration;
      }
      clearTimeout(self.timeout);
      self.quizResultData.logIdentifier = self.quiz.logIdentifier;
      self.quizResultData.quizId = self.quiz.quizId;
      self.quizResultData.questions = self.quiz.questions;
      if(self.timeCapture){
        self.quizResultData.timeCapture = self.timeCapture.captureTimeForAssessments 
        ? (self.timeCaptureOnQuiz == null 
          ? (self.timeCapture.taskClassificationTypeId == 1 
            ? self.timeCapture.sliderMinFormatives : self.timeCapture.sliderMinSummatives) : self.timeCaptureOnQuiz) : null
      }
      if(self.logData){
        self.logData.logIdentifier = self.quiz.logIdentifier;
      }

      var onSuccess = function(response) {
        self.quizResponse = response.data;
        self.finishClicked = false;
        if (self.quizResponse) {
          self.quizResponse.timeUp = val == true ? 1 : 0;

          if (self.quiz.isGraded)
            self.quizResult = true;
          else
            self.surveyResponse = true;
        }
        else {
          self.surveyResponse = true;
        }

        self.$emit("finishQuiz", self.quizResponse);
      };

      var onFinally = function() {
        self.$vs.loading.close(self.$refs.finishQuiz.$el);
      };
      
      if (!self.taskTypeId || self.taskTypeId == 9) {
        self.$ajaxPost(self, "QuizTask/LogResults", self.quizResultData, onSuccess, onFinally);
      } else if (self.taskTypeId == 14) {
        self.$ajaxPost(self, "VideoQuizTask/LogResults", self.quizResultData, onSuccess, onFinally);
      }
    },
    viewQuizResults() {
      var self = this;
      self.loadingResults = true;
      var onSuccess = response => {
        self.quizResponse = response.data;
        self.loadingResults = false;
        if (self.quiz.isGraded) self.quizResult = true;
        else self.surveyResponse = true;
        self.$emit("finishQuiz", self.quizResponse);
      };

      if (!self.taskTypeId || self.taskTypeId == 9) {
        self.$ajaxGet(self, "Quiz/ViewQuizResults?taskId=" + self.quiz.id, onSuccess);
      } else if (self.taskTypeId == 14) {
        self.$ajaxGet(self, "Quiz/ViewVideoQuizResults?taskId=" + self.quiz.id, onSuccess);
      }
    },
    areYouSure() {
      var self = this;
      self.logTempAnswer(self.index);
      self.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Attention`,
        text: self.quiz.isGraded
          ? "Are you sure you want to finish the quiz?"
          : !self.quiz.isGraded && !self.quiz.isJournal
          ? "Are you sure you want to finish the survey?"
          : "Are you sure you want to finish the quiz?",
        accept: self.finishQuiz,
        acceptText: "Finish",
        cancelText: "Cancel"
      });
    },
    submitIssue() {
      var self = this;
      self.helpPopupActive = false;

      self.errorData.osName = self.errorDataProp.osName;
      self.errorData.osVersion = self.errorDataProp.osVersion;
      self.errorData.browserName = self.errorDataProp.browserName;
      self.errorData.browserVersion = self.errorDataProp.browserVersion;
      self.errorData.navigatorUserAgent = self.errorDataProp.navigatorUserAgent;
      self.errorData.navigatorAppVersion = self.errorDataProp.navigatorAppVersion;
      self.errorData.navigatorPlatform = self.errorDataProp.navigatorPlatform;
      self.errorData.navigatorVendor = self.errorDataProp.navigatorVendor;

      self.errorData.taskId = self.taskIdProp;
      self.errorData.isMobile = self.isMobile();

      var onSuccess = response => {
        self.$vs.notify({
          title: "Information",
          color: "success",
          text: "Issue submitted!",
          position: "top-right",
          iconPack: "feather",
          icon: "icon-check"
        });
      };

      self.$ajaxPost(self, "Student/LogError", self.errorData, onSuccess);
    },
    nextQuestion() {
      var self = this;
      self.oldIndex = self.index;
      ++self.index;
      ++self.quizeIndex;
      if(this.quiz.questions[this.oldIndex].quizQuestionTypeId == 5)
        self.dragAndDropCanvasReset();

      // if((this.quiz.questions[this.index].quizQuestionTypeId == this.quiz.questions[this.oldIndex].quizQuestionTypeId) || this.quiz.questions[this.index].quizQuestionTypeId == 5)
      //   self.runDragAndDropInit = !self.runDragAndDropInit;

      self.logTempAnswer(self.oldIndex);
    },
    previousQuestion() {
      var self = this;
      self.oldIndex = self.index;
      --self.index;
      --self.quizeIndex;

      if(this.quiz.questions[this.oldIndex].quizQuestionTypeId == 5)
        self.dragAndDropCanvasReset();

      // if((this.quiz.questions[this.index].quizQuestionTypeId == this.quiz.questions[this.oldIndex].quizQuestionTypeId) || this.quiz.questions[this.index].quizQuestionTypeId == 5)
      //   self.runDragAndDropInit = !self.runDragAndDropInit;

      self.logTempAnswer(self.oldIndex);
    },
    dragAndDropCanvasReset(){
      var canvas = document.getElementById("studentCanvas");

      var ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
    },
    logQuizStarted() {
      var self = this;
      if (!self.taskTypeId || self.taskTypeId == 9) {
        self.$ajaxGet(self, `QuizTask/LogQuizStarted?logId=${self.quiz.logId}`);
      } else if (self.taskTypeId == 14) {
        self.$ajaxGet(self, `VideoQuizTask/LogQuizStarted?logId=${self.quiz.logId}`);
      } 
    },
    logQuizFinished(whenDone) {
      var self = this;
      var onSuccess = response => {
        if (whenDone && typeof whenDone == "function") whenDone();
      };
      if ((!self.taskTypeId || self.taskTypeId == 9) && (self.$acl.check("Student")) ) {
        self.$ajaxGet(self, `QuizTask/LogQuizFinished?logId=${self.quiz.logId}`,onSuccess);
      } else if (self.taskTypeId == 14 && (self.$acl.check("Student"))) {
        self.$ajaxGet(self, `VideoQuizTask/LogQuizFinished?logId=${self.quiz.logId}`,onSuccess);
      } 
      else if(self.$acl.check("Student")){
        if (whenDone && typeof whenDone == "function") whenDone();
      }
    },
    logTempAnswer(oldIndex) {
      var self = this;
      var currentQuestion = self.quiz.questions[oldIndex];

      var tempData;
      
      if (!self.taskTypeId || self.taskTypeId == 9) {
        tempData = {
          quizTaskLogId: self.quiz.logId,
          questionId: currentQuestion.id,
          answers: []
        };
      } else if (self.taskTypeId == 14) {
        tempData = {
          videoQuizTaskLogId: self.quiz.logId,
          questionId: currentQuestion.id,
          answers: []
        };
      }

      if (
        currentQuestion.quizQuestionTypeId == 1 ||
        currentQuestion.quizQuestionTypeId == 3
      ) {
        //MultipleChoiceSingleAnswer || FreeText
        tempData.answers.push({ value: currentQuestion.inputAnswer });
      } else if (currentQuestion.quizQuestionTypeId == 2) {
        //MultipleChoiceMultipleAnswers
        currentQuestion.options.forEach(option => {
          if (option.isSelected) {
            tempData.answers.push({ value: option.id });
          }
        });
      } else if (currentQuestion.quizQuestionTypeId == 4) {
        //Table
        var rowValuesWithInputAnswers = currentQuestion.rowValues.filter(
          function(item) {
            return Object.keys(item).length > 2;
          }
        );
        rowValuesWithInputAnswers.forEach(row => {
          var rowObjectKeys = Object.keys(row);
          var colNames = rowObjectKeys.filter(function(item) {
            return item != "id" && item != "question";
          });
          colNames.forEach(colName => {
            var filteredValue = currentQuestion.columnValues.filter(function(item) {
              return item.field == colName;
            });
            if(filteredValue.length > 1){
              for (let index = 0; index < filteredValue.length; index++) {
                const element = filteredValue[index];
                var colId = element.id;
                var rowId = row.id;
                var inputAnswer = row[colName];

                tempData.answers.push({
                  value: inputAnswer,
                  quizQuestionColumnId: colId,
                  quizQuestionRowId: rowId
                });
              }
            }
            if(filteredValue.length == 1){
              var colId = filteredValue[0].id;
              var rowId = row.id;
              var inputAnswer = row[colName];

              tempData.answers.push({
                value: inputAnswer,
                quizQuestionColumnId: colId,
                quizQuestionRowId: rowId
              });
            }
          });
        });
      } else if (currentQuestion.quizQuestionTypeId == 5) {
        //DragAndDrop
        currentQuestion.dragAndDropMapLocations.forEach(option => {
          if(option.selectedXCoordinate){
            tempData.answers.push({
              DragAndDropMapLocationId: option.id,
              XCoordinate: option.selectedXCoordinate,
              YCoordinate: option.selectedYCoordinate,
            });
          }
        });
      } else if (currentQuestion.quizQuestionTypeId == 6){
        tempData.answers.push({
          UploadedFile: currentQuestion.uploadedFile
        })
      }

      if (!self.taskTypeId || self.taskTypeId == 9) {
        self.$ajaxPost(self, "QuizTask/TempLogAnswer", tempData);
      } else if (self.taskTypeId == 14) {
        self.$ajaxPost(self, "VideoQuizTask/TempLogAnswer", tempData);
      } 

    },
    initQuizAndQuestions() {
      var self = this;
      // self.logData.quizId = self.quiz.quizId; ----- we can maybe do this do prevent that QuizId = 0 bug in the QuizTaskLog table
      if (self.$refs.whole_page) {
        self.showLoadingOnElement("whole_page", 1, "material");
      }
      var onSuccess = response => {
        self.quiz.questions = response.data.questions;
        self.quiz.showRetryOption = response.data.showRetryOption;
        self.quiz.showContinueOption = response.data.showContinueOption;
        self.quiz.showStartOption = response.data.showStartOption;
        self.quiz.showSkipOption = response.data.showSkipOption;
        self.quiz.showRedoOption = response.data.showRedoOption;
        self.quiz.logId = response.data.logId;
        self.quiz.logIdentifier = response.data.logIdentifier;
        self.quiz.startedOn = response.data.startTime;
        self.quiz.imageUrl = response.data.imageUrl;
        self.quiz.canSkip = response.data.canSkip;
        if (
          !self.quiz.showRetryOption &&
          !self.quiz.showContinueOption &&
          !self.quiz.showStartOption &&
          !self.quiz.showSkipOption
        ) {
          self.viewQuizResults();
        }

        if (self.quiz.showContinueOption) {
          self.continueTimer();
        }
      };

      var onFinally = response => {
        if (self.$refs.whole_page) {
          self.$vs.loading.close(self.$refs.whole_page.$el);
        }
      };
      if(this.$route.name != 'Menu'){
        if (!self.taskTypeId || self.taskTypeId == 9) {
          self.$ajaxPost(self, "QuizTask/StartLogEntry", self.logData, onSuccess, onFinally);
        } else if (self.taskTypeId == 14) {
          self.$ajaxPost(self, "VideoQuizTask/StartLogEntry", self.logData, onSuccess, onFinally);
        }
      }else{
        setTimeout(() => {
          if (self.$refs.whole_page) {
            self.$vs.loading.close(self.$refs.whole_page.$el);
          }
        }, 100);
      }
    },
    endQuizTaskLog(whenDone) {
      var self = this;

      self.logData.toTaskId = self.logData.taskId;
      var oldLogData = self.logData;
      oldLogData.logIdentifier = self.quiz.logIdentifier;

      var onSuccess = response => {
        if (whenDone && typeof whenDone == "function") whenDone();
      };

      if (!self.taskTypeId || self.taskTypeId == 9) {
        self.$ajaxPost(self, "QuizTask/EndLogEntry", oldLogData, onSuccess);
      } else if (self.taskTypeId == 14) {
        self.$ajaxPost(self, "VideoQuizTask/EndLogEntry", oldLogData, onSuccess);
      }
    },
    showLoadingOnElement(element, scale, type) {
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    backToStudentMenu(){
      this.$emit("backToStudentMenu");
    },
    displayOneTaskAttemptPopup(){
      var self = this;
      if(this.$getTaskAttempt()){
        self.$swal({
          title: 'Before you Start',
          icon:'info',
          html: "If this is not your first attempt, by redoing this task all other attempts will be <strong>DISCARDED</strong>. Only your last attempt will be recorded.",
          customClass: {
            confirmButton: 'vs-component vs-button vs-button-primary vs-button-filled',
          },
          buttonsStyling: false,
        });
      }
    }

  }
};
</script>

<style lang="scss">

@import "@/digicampus/assets/main-digi.scss";

#back-arrow-quiz {
  position: absolute;
  top:50%;
  left: 0;
  margin-left: 7px;
  width: 50px;
  z-index: 50000;

  &:hover {
    width: 55px;
    cursor: pointer;
    fill: white;
  }

  &:active {
    width: 60px;
    cursor: pointer;
    opacity: 0.8;
  }
}

.overflowCardScroll {
  overflow-x: hidden !important;
  overflow-y: scroll !important;
}

.contentCards {
  margin: auto;
}

.vs-button-light.vs-button-border:hover,
.vs-button-light.vs-button-flat:hover {
  background: rgba(245, 245, 245, 0.3) !important;
}

#quiz-card #back-to-menu-button {
  position: absolute;
  -webkit-box-shadow: 0px 0px 9px 3px black;
  box-shadow: 0px 0px 9px 3px black;
  margin-left: 6px;
  margin-top: 6px;
  top: -32px;
  left: 2px;
}

#next-task-button {
  position: absolute;
  bottom: 0;
  right: 0;
  box-shadow: 0px 0px 9px 3px rgb(0, 0, 0);
}

.con-vs-dialog {
  z-index: 53500;
}

.vx-card__body{
  text-align: justify !important;
}

@media screen and (max-width: 550px) {
  .vs-button-border{
    padding: 5px;
  }
  .timestandalone{
    margin-top: 80px !important;
    margin-right: 20px;
  }  
}
#courseviewerquiz{
  .centersubmitbutton {
    position: fixed !important;
    bottom: 1%;
    width: 100%;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
  }
}


.heading{
  font-size: 40px;
  font-weight: bold;
  text-align: left;
}

.quiz-description{
  font-size: 20px;
  font-weight: bold;
  text-align: left;
}

// #courseviewerquiz {
//   .vx-card__body{
//     padding: 0px !important;
//   }
// }
  
.quizheading{
  font-size: 20px;
  font-weight: bold;
}

.startbuttons{
  z-index: 1000;
  padding: 0 !important;
  margin: 0 auto;
  bottom: 0px;
  overflow: visible;
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 2%;
}

@media screen  and(max-width:420px) {
  .startbuttons{
    flex-direction: column;
    button:first-child{
      margin-bottom:5px ;
    }
  }
}


.nextbuttons{
  z-index: 1000;
  padding: 0 !important;
  margin: 0 auto;
  bottom: 0px;
  overflow: visible;
  position: fixed;
  display: flex;
  justify-content: center;
  width: 100%;
  margin-bottom: 2%;
}

.buttoncontainer{
  border: 2px solid black;
  border-radius: 20px;

  .vs-button{
    background: transparent !important;
    color: black;
    margin: 2px 0px 20px 0px;

    :hover{
      box-shadow: none !important;
    }
  }
}

.vs-button{
  &:hover{
      box-shadow: unset !important;
    }
}

.quizimage{
  width: 40%;
  display: flex;
  justify-content: center;
  margin: 0 auto;
  padding: 20px 0px;
}

@media screen and (max-width: 500px) {
  p img{
    width: 100%;
  }
    .quizimage{
      width: 80%;
    }
}

.helpful_btns__container {
  .helpful_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }
  //da1e26 - b11638 rooi || 1caf00 - 037500 groen
  #helpful-btn {
    border-radius: 25px 0 0 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #unhelpful-btn {
    border-radius: 0 25px 25px 0 !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #start-btn {
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }
  #skip-btn {
    border-radius: 25px !important;
    //background-image: linear-gradient(#38c41c,  #38c41c) !important;

  }
}

.next_btns__container {
  .next_btns {
    .vs-button--text {
      text-transform: uppercase !important;
    }

    .vs-icon {
      font-size: 1.2rem !important;
    }

    width: 100% !important;
  }
  //da1e26 - b11638 rooi || 1caf00 - 037500 groen
  #left-btn {
    border-radius: 25px 0 0 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #right-btn {
    border-radius: 0 25px 25px 0 !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }

  #next-btn {
    z-index: 999999999;
    border-radius: 25px !important;
    background-image: linear-gradient(#1c80c4,  #2367a7) !important;
  }
}

.vs-button-warning.vs-button-filled{
  &:hover{
    animation: buttonAnimation .3s normal;
  }
}

.vs-button-primary.vs-button-flat{
  &:hover{
    animation: buttonAnimation .3s normal;
  }
}

.timer {
  width: 10%;
  background-color: #f01;
  color: #f01;
  padding-bottom: 6px;
  border-radius: 30px;
  border-style: solid;
  border-width: 2px;
  border-color: white;
  display: flex;
  justify-content: center;
  background-color: transparent;
  font-size: 20px;
  border: none;
}

.helpbuttonforstandalone{
  width: 100% !important;
  justify-content: left !important;
  position: absolute !important;
  left: 0;
  bottom: 0;
}

.helpbuttonforquizpop{
  width: 100% !important;
  justify-content: left !important;
  position: absolute !important;
  left: 2% !important;
  bottom: 3% !important;
}

.timerdiv{
  justify-content: center;
}

.hoursUsed{
  display:flex ;
  justify-content: center ;
  justify-items: center;
  flex-direction: column;
  text-align: center;
  align-items: center;
  width: 70%;
  margin: 0 auto;
}

@media screen and (max-width: 900px) {  
  .hoursUsed{
    width: 90%;
  }
}

.vue-slider-rail {
    background-color: whitesmoke;
    border-radius: 15px;
    -webkit-transition: background-color .3s;
    transition: background-color .3s;
}

.vue-slider-marks {
    position: relative;
    width: 100%;
    height: 100%;
}

.vue-slider-dot {
    position: absolute;
    -webkit-transition: all 0s;
    transition: all 0s;
    z-index: 5;
}

.vue-slider-process {
    background-color: #9cd5ff;
    border-radius: 15px;
    -webkit-transition: background-color .3s;
    transition: background-color .3s;
}

.vue-slider-mark {
    position: absolute;
    z-index: 1;
}

.vue-slider-dot-handle {
    cursor: pointer;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    border: 2px solid #9cd5ff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    -webkit-transition: border-color .3s, -webkit-box-shadow .3s;
    transition: border-color .3s, -webkit-box-shadow .3s;
    transition: box-shadow .3s, border-color .3s;
    transition: box-shadow .3s, border-color .3s, -webkit-box-shadow .3s;
}

#quize-counter { 
  position: fixed !important;
  bottom: 31px !important;
  right: 31px !important;
  z-index: 50000;
  margin-bottom: 5px;
  &.vs-button.large .vs-button--icon {
    font-size: 1.75rem !important;
  }
}

</style>
